import * as t from "./types";
import * as actions from "./action";

/* Account User */
export const getAccountUsersAction = (
  payload: t.GetAccountUsersRequestType
): t.GetAccountUsersActionType => {
  return {
    type: actions.GET_ACCOUNT_USERS,
    payload,
  };
};

export const addAccountUserAction = (
  payload: t.AddAccountUserRequestType
): t.AddAccountUserActionType => {
  return {
    type: actions.ADD_ACCOUNT_USER,
    payload,
  };
};

export const deleteAccountUserAction = (
  payload: t.DeleteAccountUserRequestType
): t.DeleteAccountUserActionType => {
  return {
    type: actions.DELETE_ACCOUNT_USER,
    payload,
  };
};
